export const NUM_SKELETON = Object.freeze({
  LIST_ITEMS: 8
})
